









































import mixins from 'vue-typed-mixins'
import DiaryMixin from '../../DiaryMixin'

import Situation from './Situation.vue'

export default mixins(DiaryMixin).extend({
  components: { Situation },
})
